/**
 * NMS Defer Pixels
 * 
 * Intercepts and delays Shopify web pixels (Clarity, Convert, Snapchat, etc.)
 * to prevent main thread blocking on first page load.
 * 
 * MUST load immediately after content_for_header.
 */
(function() {
  'use strict';
  
  // Store original methods
  const originalCreateElement = document.createElement.bind(document);
  const originalAppendChild = Element.prototype.appendChild;
  const originalInsertBefore = Element.prototype.insertBefore;
  
  const deferredScripts = [];
  let pixelsLoaded = false;
  
  // Intercept script creation from web pixels
  document.createElement = function(tagName) {
    const element = originalCreateElement(tagName);
    
    if (tagName.toLowerCase() === 'script' && !pixelsLoaded) {
      // Mark script for deferred loading
      element._nmsDeferred = true;
    }
    
    return element;
  };
  
  // Intercept script insertion
  function interceptScriptInsertion(original, args) {
    const node = args[0];
    
    if (node && node.tagName === 'SCRIPT' && node._nmsDeferred && !pixelsLoaded) {
      // Defer this script
      deferredScripts.push({
        script: node,
        parent: this,
        method: original,
        args: args
      });
      
      console.log('[DeferPixels] Deferred pixel script:', node.src || 'inline');
      return node;
    }
    
    return original.apply(this, args);
  }
  
  Element.prototype.appendChild = function() {
    return interceptScriptInsertion.call(this, originalAppendChild, arguments);
  };
  
  Element.prototype.insertBefore = function() {
    return interceptScriptInsertion.call(this, originalInsertBefore, arguments);
  };
  
  // Load all deferred pixels
  function loadPixels() {
    if (pixelsLoaded) return;
    pixelsLoaded = true;
    
    console.log(`[DeferPixels] Loading ${deferredScripts.length} deferred pixel scripts`);
    
    // Restore original methods
    document.createElement = originalCreateElement;
    Element.prototype.appendChild = originalAppendChild;
    Element.prototype.insertBefore = originalInsertBefore;
    
    // Execute deferred scripts
    deferredScripts.forEach(function(item) {
      try {
        item.method.apply(item.parent, item.args);
      } catch (error) {
        console.error('[DeferPixels] Error loading pixel:', error);
      }
    });
    
    deferredScripts.length = 0;
    
    // Remove interaction listeners
    ['click', 'scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function(evt) {
      window.removeEventListener(evt, loadPixels);
    });
  }
  
  // Load on first user interaction
  ['click', 'scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function(evt) {
    window.addEventListener(evt, loadPixels, { once: true, passive: true });
  });
  
  // Fallback: Load 2 seconds after DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(loadPixels, 2000);
    });
  } else {
    setTimeout(loadPixels, 2000);
  }
  
  console.log('[DeferPixels] Initialized - Web pixels will load on interaction or after 2s');
})();
    